import React from 'react';
import type { DownloadAlertFilters as DownloadAlertFilterValues } from '../../../models/downloadAlert';

export interface DownloadAlertsFiltersProps {
  filters: DownloadAlertFilterValues;
  onChange: (next: DownloadAlertFilterValues) => void;
}

export function DownloadAlertsFilters({ filters, onChange }: DownloadAlertsFiltersProps): React.ReactElement {
  return (
    <div className="bo-admin-toolbar bo-card">
      <label className="bo-field" htmlFor="download-alerts-user">
        <span className="bo-field-label">User</span>
        <input
          id="download-alerts-user"
          type="text"
          className="bo-input"
          placeholder="User id"
          value={filters.userId ?? ''}
          onChange={(event) => onChange({ ...filters, userId: event.target.value || undefined })}
        />
      </label>
      <label className="bo-field" htmlFor="download-alerts-company">
        <span className="bo-field-label">Company</span>
        <input
          id="download-alerts-company"
          type="text"
          className="bo-input"
          placeholder="Company id"
          value={filters.companyId ?? ''}
          onChange={(event) => onChange({ ...filters, companyId: event.target.value || undefined })}
        />
      </label>
      <label className="bo-field" htmlFor="download-alerts-severity">
        <span className="bo-field-label">Severity</span>
        <select
          id="download-alerts-severity"
          className="bo-input"
          value={filters.severity ?? ''}
          onChange={(event) => onChange({ ...filters, severity: event.target.value || undefined })}
        >
          <option value="">All</option>
          <option value="info">Info</option>
          <option value="warning">Warning</option>
          <option value="critical">Critical</option>
        </select>
      </label>
      <label className="bo-field" htmlFor="download-alerts-from-date">
        <span className="bo-field-label">From</span>
        <input
          id="download-alerts-from-date"
          type="date"
          className="bo-input"
          value={filters.fromUtc ?? ''}
          onChange={(event) => onChange({ ...filters, fromUtc: event.target.value || undefined })}
        />
      </label>
      <label className="bo-field" htmlFor="download-alerts-to-date">
        <span className="bo-field-label">To</span>
        <input
          id="download-alerts-to-date"
          type="date"
          className="bo-input"
          value={filters.toUtc ?? ''}
          onChange={(event) => onChange({ ...filters, toUtc: event.target.value || undefined })}
        />
      </label>
      <label className="bo-field" htmlFor="download-alerts-include-resolved">
        <span className="bo-field-label">Include resolved</span>
        <input
          id="download-alerts-include-resolved"
          type="checkbox"
          checked={filters.includeResolved ?? false}
          onChange={(event) => onChange({ ...filters, includeResolved: event.target.checked || undefined })}
        />
      </label>
    </div>
  );
}
